import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {


  /*  public URLServeImg = 'http://192.168.1.115:8081/tiagoguim/view/';
   public URLServe = 'http://192.168.1.115:8081/tiagoguim/view/';
   */
 //     public URLServeImg = 'https://app.tiagoguim.com.br/api/view/user/';
         //public URLServe = 'https://app.tiagoguim.com.br/api/view/user/';
  //public URLServeContent = 'https://app.tiagoguim.com.br/api/view/';
  public URLbase = 'https://tiagoguim.bitsenior.com.br/api';
  public URLServeImg = this.URLbase + '/view/user/';
  public URLServe = this.URLbase + '/view/user/';
  public URLServeAdmin = this.URLbase + '/view/';
  public URLServeContent = this.URLbase + '/view/';
  public isServe = true;

  constructor() {
    this.isServe = true;
  }
  getURL() {
    if (this.isServe) {
      return this.URLServe;
    } else {
      // return this.URLLocal ;
    }
  }

  getURLServe(name: string, admin: boolean = false) {
    if (this.isServe) {
      if (admin) {
        return this.URLServeAdmin + name + '.php';
      } else {
        return this.URLServe + name + '.php';
      }
    } else {
     
    }

  }

  monthName(mes) {
    const nomeMes = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
    return nomeMes[mes - 1];
  }
}
